import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPrint = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.698 2.428A1.46 1.46 0 0 1 7.73 2h8.539a1.46 1.46 0 0 1 1.461 1.462v4.23h2.096A2.173 2.173 0 0 1 22 9.865v6.404a2.173 2.173 0 0 1-2.173 2.173H17.73v2.096A1.46 1.46 0 0 1 16.27 22H7.732a1.46 1.46 0 0 1-1.461-1.462v-2.096H4.173A2.173 2.173 0 0 1 2 16.27V9.865a2.173 2.173 0 0 1 2.173-2.173H6.27v-4.23c0-.388.154-.76.428-1.034M16.98 9.192H4.173a.673.673 0 0 0-.673.673v6.404a.673.673 0 0 0 .673.673H6.27v-1.384a.75.75 0 0 1 .75-.75h9.961a.75.75 0 0 1 .75.75v1.384h2.096a.673.673 0 0 0 .673-.673V9.865a.673.673 0 0 0-.673-.673H16.98m-.75-5.692v4.192H7.77V3.5zm0 14.17v2.83H7.77v-4.192h8.461zm.038-6.42a.75.75 0 0 0 0 1.5h1.423a.75.75 0 0 0 0-1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPrint;
